const OrganAPI = {
    /**
     * 获取组织列表
     * @param {*} query 
     * @returns 
     */
    loadOrgans(query) {
        return Request.post(`/admin/organ/search`, query || {});
    },
    /**
     * @description: 获取组织机构树
     * @param {*} query
     * @return {*}
     */
    loadOrganTree(query) {
        return Request.post(`/admin/organ/tree`, query || {});
    },
    /**
     * 获取组织详情
     * @param {*} id 
     * @returns 
     */
    getOrganById(id) {
        return Request.get(`/admin/organ/${id}`);
    },

    /**
     * 删除单位
     */
    removeOrgan(organId) {
        return Request.delete(`/admin/organ/delete/${organId}`);
    },
    /**
     * 删除单位
     */
    batchRemoveOrgans(organIdArray) {
        return Request.post(`/admin/organ/batchDelete`, organIdArray);
    },
    /**
     * 保存组织
     */
    saveOrgan(corp) {
        return Request.post('/admin/organ/save', corp);
    },
    /**
     * 更改机构状态
     * @param {*} id 
     * @param {*} status 
     * @returns 
     */
    changeOrganValid(id, status) {
        return Request.get(`/admin/organ/${id}/changeValid`, { validStatus: status });
    },
    /**
     * 获取组织列表
     * @param {*} query 
     * @returns 
     */
    loadOrganServices(query) {
        return Request.post(`/admin/organApp/search`, query);
    },
    /**
     * 删除租户服务
     */
    removeOrganService(id) {
        return Request.delete(`/admin/organApp/delete/${id}`);
    },
    /**
     * 删除租户服务
     */
    batchRemoveOrganServices(idArray) {
        return Request.post(`/admin/organApp/batchDelete`, idArray);
    },
    /**
     * 保存租户服务
     */
    saveOrganService(data) {
        return Request.post('/admin/organApp/save', data);
    },
    /**
     * 查找租户用户
     */
    findOrganUsers(query) {
        return Request.post('/admin/organUser/findOrganUsers', query);
    },
    /**
     * 保存租户用户
     */
    saveOrganUsers(data) {
        return Request.post('/admin/organUser/addAccounts', data);
    },
    removeOrganUser(id) {
        return Request.delete(`/admin/organUser/${id}/delete`);
    },
    batchRemoveOrganUsers(idArray) {
        return Request.post('/admin/organUser/batchDelete', idArray);
    },
    findOrganAppIdentityTree(query) {
        return Request.post('/admin/organApp/searchOrganAppMenuTemplate', query);
    },
    findIdentityUsers(query) {
        return Request.post('/admin/userIdentity/findIdentityUsers', query);
    },
    removeUserIdentity(id) {
        return Request.delete(`/admin/userIdentity/delete/${id}`);
    },
    batchRemoveUserIdentity(idArray) {
        return Request.post('/admin/userIdentity/batchDelete', idArray);
    },
    saveUserIdentity(data) {
        return Request.post('/admin/userIdentity/save', data);
    }
};
export default OrganAPI;